<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="chapter3">
<h1 class="left"><a href="#/004toc#january3">January 3</a></h1>
<p class="noindent">With your good looks and easygoing nature you’re destined to attract many admirers. Some will have your best interests at heart. Others will attempt to lure you into secluded parks where no one will be able to hear you scream. True wisdom is being able to tell which is which.</p>
<p class="indent"><em>Unlucky numbers:</em> 81, 203, 205</p>
<div class="image" id="image5">
<p class="center"><img alt="image 5" src="images/StarRule.jpg"/></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 008chapter3.vue?4f060b50